import { apiDelete, apiPost, apiRoutes, buildApiRoute, createStandardCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type RoleDto = EntityRecord;
export type RoleCreateRequest = EntityCreateRequest;
export type RoleUpdateRequest = EntityUpdateRequest;
export type RolePermissionAssignmentRequest = Readonly<{ permissionId: string }>;

const roleCrud = createStandardCrudApi<RoleDto, RoleCreateRequest, RoleUpdateRequest>({
  list: apiRoutes.roles.list,
  get: apiRoutes.roles.get,
  create: apiRoutes.roles.create,
  update: apiRoutes.roles.update,
  delete: apiRoutes.roles.delete,
});

export const roleApi: CrudApi<RoleDto, RoleCreateRequest, RoleUpdateRequest> & {
  readonly assignPermission: (id: string, payload: RolePermissionAssignmentRequest, idempotencyKey?: string) => Promise<RoleDto>;
  readonly removePermission: (id: string, permissionId: string) => Promise<void>;
} = {
  ...roleCrud,
  assignPermission: (id, payload, idempotencyKey) => apiPost<RoleDto>(buildApiRoute(apiRoutes.roles.assignPermission, { id }), payload, { idempotencyKey }),
  removePermission: async (id, permissionId) => { await apiDelete<void>(buildApiRoute(apiRoutes.roles.removePermission, { id, permissionId })); },
};
